import { render, staticRenderFns } from "./Typography4.vue?vue&type=template&id=634efb00&scoped=true"
import script from "./Typography4.vue?vue&type=script&lang=js"
export * from "./Typography4.vue?vue&type=script&lang=js"
import style0 from "./Typography4.vue?vue&type=style&index=0&id=634efb00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634efb00",
  null
  
)

export default component.exports